import React from 'react';

const OperationalExcellence = () => {
  return (
    <div className="accordion-body">
      <div className="content">
      <div className="commitement-content">
          <p>
            We strive for all-round operational excellence to achieve benchmark performance across our business, by debottlenecking our assets to enhance production,
            supported by improved digital and technology solutions. Our efforts are focused on enhancing profitability by optimising our cost and improving 
            realisation through the right marketing strategies.
          </p>
        </div>

        <div className="commitement-content commitment-kits">
          <h5>KPIs</h5>
          <ul className="green-bullets">
            <li>EBITDA</li>
            <li>Adj. EBITDA margin</li>
            <li>FCF post-capex</li>
            <li>ROCE</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>Risks</h5>
          <ul className="green-bullets">
            <li>Fluctuation in commodity prices (including oil) and currency exchange rates</li>
            <li>HSE</li>
          </ul>
          <ul className="green-bullets">
            <li>Tailings dam stability</li>
            <li>Loss of assets or profit due to natural calamities</li>
          </ul>
        </div>

        <div className="commitement-content commitment-risks">
          <h5>FY2020 Update</h5>
          <h6>Zinc India</h6>
          <ul className="green-bullets">
            <li>Record ore production of 14.5 million tonnes despite disruptions on account of COVID-19</li>
          </ul>
          <ul className="green-bullets">
            <li>Mined metal production of 917 kt and refined zinc-lead production of 870 kt</li>
          </ul>

          <h6>Zinc International</h6>
          <ul className="green-bullets">
            <li>Cost of production at US$1,665/t, down 13% y-o-y</li>
            <li>Increase in Gamsberg production volume from 17 kt in FY2019 to 108 kt in FY2020</li>
          </ul>
          <ul className="green-bullets">
            <li>During FY2020, total production stood at 240 kt, 63% higher y-o-y. This was primarily due to ramp up of first phase of Gamsberg expansion plan</li>
          </ul>

          <h6>Oil & Gas</h6>
          <ul className="green-bullets">
            <li>Development rigs as on March 2020, with 136 wells drilled and 41 wells hooked up during the year.</li>
            <li>Two new wells hooked up in Ravva block adding ~10 kboepd of incremental volumes</li>
            <li>Gas production for Rajasthan block increased by 122% to 79 mmscfd as early production facility fully commissioned with ramped up volumes to ~127 mmscfd</li>
            <li>Implemented largest Full Tensor Gravity Gradiometry™ (FTG) airborne survey in India covering an area of 1,200 LKM in Assam blocks and 8000 LKM in Kutch blocks.</li>
          </ul>
          <ul className="green-bullets">
            <li>Satellite-based Sub-Terrain prospecting (STeP®) applied in Assam, which includes eight remote sensing and computational technologies covering an area of
              3,650 sq km</li>
            <li>Seismic acquisition programme commenced in Assam and Kutch; 1,100 sq km in Kutch and 120 sq km, 265 LKM completed in Assam.</li>
            <li>Production Sharing Contracts (PSC) signed for Ravva block extended for 10 years</li>
          </ul>

          <h6>Aluminium & Power</h6>
          <ul className="green-bullets">
            <li>India’s highest aluminium production at 1,904 kt</li>
            <li>Record alumina production from Lanjigarh refinery at 1,811 kt, up 21% y-o-y, through continued debottlenecking</li>
            <li>Q4FY20 Lanjigarh cost of production lowest quarterly ever at 258 $/T</li>
            <li>Q4FY20 hot metal cost of production significantly lower at US$ 1,451 per tonne, 20% lower y-o-y</li>
          </ul>
          <ul className="green-bullets">
            <li>CoP of alumina improved to US$ 275 per tonne, due to benefits from increase in locally sourced bauxite, continued debottlenecking, improved plant operating
                parameters and rupee depreciation</li>
            <li>Record PAF of 91% at the 1,980MW TSPL plant in FY2020</li>
          </ul>

          <h6>Steel</h6>
          <ul className="green-bullets">
            <li>Cost decreased by 9% y-o-y from 457 $/T to 418 $/T in FY2020</li>
          </ul>
          <ul className="green-bullets">
            <li>Healthy margin of ~127 $/T during the last quarter</li>
          </ul>

          <h6>Copper and Iron Ore</h6>
          <ul className="green-bullets">
            <li>Production of saleable ore at Karnataka at 4.4 million tonnes, up 6% y-o-y</li>
            <li>Iron Ore sales at Karnataka at 5.8 million tonnes, up 125% higher y-o-y due to an increase in production and stock liquidation at Karnataka by 1.4 MT.</li>
          </ul>
          <ul className="green-bullets">
            <li>Production of pig iron decreased by 1% to 681,000 tonnes in FY2020, mainly due to improved coke availability during the year and other operational
                efficiencies.</li>
            <li>Continued engagement with the government and local communities to restart operations at Goa and Tuticorin</li>
          </ul>

        </div>
      </div>
    </div>
  );
}

export default OperationalExcellence;